export enum ZkUserGroup {
  NONE = 'NONE',
  MAIN_PERSONNEL = 'MAIN_PERSONNEL'
}
